import { NewEmployeeModel } from '../../../../model/employee.model';
import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';

export const RequestAction = createAction('[New Employee view] get data',
  props<{ id: number }>());
export const ResponseAction = createAction('[New Employee view] set data', props<{ payload: NewEmployeeModel }>());